
import ApplesApi from "../../../../../../server/com/silkplm/rpc/healthcheck/fruits/ApplesApi.js";

class Fruits{
    constructor() {

            /** @type {module:src/server/com/silkplm/rpc/healthcheck/fruits/ApplesApi.ApplesApi} */
            this.ApplesApi = new ApplesApi();
    }
}

export default Fruits;

